module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"add":"Add platform","add_tt":"If you do not find a platform in our extensive list, you can add one here"},"cs":{"add":"Přidat platformu","add_tt":"Pokud nenajdete platformu v našem rozsáhlém seznamu, můžete ji přidat zde"}}')
  delete Component.options._Ctor
}
